import React, { useState } from 'react';
import {
  FDAccordion, FDAccordionDetails, FDAccordionTitle, FDIcon, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { RoadmapExplorerGoalRow } from 'Components/UI/roadmapExplorer/goalsAccordion/row';
import PropTypes from 'prop-types';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { RoadmapExplorerGoalFundedProgress } from './goalFundedProgress';

export const RoadmapExplorerGoalAccordionLayout = ({ condensed }) => {
  const { resource } = useMetaLayoutContext();
  const [expanded, setExpanded] = useState(false);
  const { logStandardizedEvent } = useEventTrackingLogEvent({
    nodeName: 'Roadmap explorer goals accordion',
  });

  const title = (
    <RoadmapExplorerGoalRow
      condensed={condensed}
      name={(
        <>
          <FDIcon icon={resource.attr('icon')} />
          <MetaControlField attr="name" />
        </>
      )}
      progress={<RoadmapExplorerGoalFundedProgress resource={resource} tooltipTitle={resource.attr('tooltipTitle')} tooltipBody={resource.attr('tooltipBody')} />}
      goalAmount={<MetaControlField attr="goalAmount" />}
      goalDate={<MetaControlField attr="goalDate" />}
    />
  );
  if (condensed) {
    return <FDStack direction="row" padding={2}>{title}</FDStack>;
  }
  return (
    <FDAccordion
      expanded={expanded}
      onChange={(shouldBeExpanded) => {
        if (shouldBeExpanded) {
          logStandardizedEvent(categories.pm1OrPM2, eventTypes.expandGoal, shouldBeExpanded ? 'expanding' : 'closing', { eventProperties: { icon: resource.attr('icon') } });
        }
        setExpanded(shouldBeExpanded);
      }}
    >
      <FDAccordionTitle>{title}</FDAccordionTitle>
      <FDAccordionDetails>
        <MetaControlField attr="details" />
      </FDAccordionDetails>
    </FDAccordion>
  );
};

RoadmapExplorerGoalAccordionLayout.propTypes = {
  condensed: PropTypes.bool,
};
